import { render } from "./Mainselect.vue?vue&type=template&id=1c09663f&scoped=true"
import script from "./Mainselect.vue?vue&type=script&lang=js"
export * from "./Mainselect.vue?vue&type=script&lang=js"

import "./Mainselect.vue?vue&type=style&index=0&id=1c09663f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c09663f"]])

export default __exports__